export default __webpack_public_path__ + "static/media/orange_insight.9505b5e7.svg";